<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap v-if="renderComponent">
      <v-flex xs12 md8>
        <material-card
            class="card-tabs" color="green">
          <v-flex
              slot="header"
          >
            <v-tabs
                v-model="active_tab"
                color="transparent"
                slider-color="white"
            >
              <span
                  class="subheading font-weight-light mr-3"
                  style="align-self: center"
              >Languages:</span>
              <v-tab
                  v-for="(language,index) of languages"
                  :key="index+1"
                  @click="changeLanguage('tab-'+index+1, index)"
                  :href="`#tab-${index+1}`"
                  class="mr-3">
                {{language.name}}
              </v-tab>
            </v-tabs>
          </v-flex>
          <v-tabs-items v-model="active_tab">
            <v-tab-item
                v-for="(language, index) of languages"
                :key="index+1"
                :value="`tab-${index+1}`"
            >
              <v-list three-line>
                <v-list-tile>
                  <v-flex md12>
                    <v-form :ref="'form' + language.name" v-model="language.validpostForm">
                      <v-layout wrap>
                        <v-flex xs12 md12 >
                          <v-text class="lable-tip1">SKU : Mandatory field, write your own internal reference name for this page. It could the SKU number you use internally or a general name.</v-text>
                          <v-text-field v-model="sku" @input="checkUniqueSku" label="SKU">
                          </v-text-field>
                          <sub v-if="skuError"> {{ skuError }} </sub>
                        </v-flex>
                        <v-flex xs12 md12>
                          <v-text class="lable-tip1">Association Code : Find the Association Code on the side of the sticker rolls. For example : ROLL_XXX379_0009</v-text>
                          <v-combobox multiple
                                      v-model="select"
                                      @input="verifyTags"
                                      label="Association Code"
                                      append-icon
                                      chips
                                      deletable-chips
                                      class="tag-input"
                                      @keyup.backspace="updateTags"
                                      @keyup.tab="updateTags"
                                      @blur="addPendingTags"
                                      @paste="updateTags">
                          </v-combobox>
                          <sub v-for="error in errorMsg"> {{ error }} </sub>
                        </v-flex>
                        <v-flex xs12 md12>
                          <v-text-field v-if="index === 0" :rules="middleTitleRules" v-model="language.postData.top_middle_title" label="Top middle title" class="purple-input"/>
                          <v-text-field v-if="index !== 0" :rules="middleTitleRules" v-model="language.postData.top_middle_title" label="Top middle title" class="purple-input"/>
                        </v-flex>
                        <v-flex xs12 md12>
                          <v-text-field
                              v-model="language.postData.info_title_1"
                              label="Title 1:"
                              class="purple-input"/>
                        </v-flex>
                        <v-flex xs12 md12>
                          <v-textarea
                              rows="1"
                              auto-grow
                              v-model="language.postData.info_small_title_1"
                              label="Text 1:"
                              class="purple-input"/>
                        </v-flex>
                        <v-flex xs12 md12>
                          <v-text-field
                              v-model="language.postData.info_title_2"
                              label="Title 2:"
                              class="purple-input"/>
                        </v-flex>
                        <v-flex xs12 md12>
                          <v-textarea
                              rows="1"
                              auto-grow
                              v-model="language.postData.info_small_title_2"
                              label="Text 2:"
                              class="purple-input"/>
                        </v-flex>
                        <v-flex xs12 md12>
                          <v-text-field
                              v-model="language.postData.info_title_3"
                              label="Title 3:"
                              class="purple-input"/>
                        </v-flex>
                        <v-flex xs12 md12>
                          <v-textarea
                              rows="1"
                              auto-grow
                              v-model="language.postData.info_small_title_3"
                              label="Text 3:"
                              class="purple-input"/>
                        </v-flex>
                        <v-flex xs12 md12>
                          <v-text-field
                              v-model="language.postData.info_title_4"
                              label="Title 4:"
                              class="purple-input"/>
                        </v-flex>
                        <v-flex
                            xs12
                            md12
                        >
                          <v-textarea
                              rows="1"
                              auto-grow
                              v-model="language.postData.info_small_title_4"
                              label="Text 4:"
                              class="purple-input"/>
                        </v-flex>
                        <v-flex
                            xs12
                            md12
                        >
                          <v-text-field
                              v-model="language.postData.info_title_5"
                              label="Title 5:"
                              class="purple-input"/>
                        </v-flex>
                        <v-flex
                            xs12
                            md12
                        >
                          <v-textarea
                              rows="1"
                              auto-grow
                              v-model="language.postData.info_small_title_5"
                              label="Text 5:"
                              class="purple-input"/>
                        </v-flex>
                        <!--  Step1-->
                        <v-flex
                            xs12
                            md12
                        >
                          <v-btn
                              v-if="!step"
                              dark
                              fab
                              bottom
                              right
                              color="grey"
                              style="float: right; left: 0;"
                              @click="step ='step1'"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex v-if="step === 'step1' || step === 'step2' || step === 'step3'" xs12 md12>
                          <v-textarea
                              rows="1"
                              auto-grow
                              v-model="language.postData.fake_product_text"
                              label="Fake product Text"
                              class="purple-input"/>
                        </v-flex>
                        <!--  Step2-->
                        <v-flex
                            xs12
                            md12
                        >
                          <v-btn
                              v-if="step !== 'step3' && step === 'step1'"
                              dark
                              fab
                              bottom
                              right
                              color="grey"
                              style="float: right; left: 0;"
                              @click="step ='step2'"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex v-if="step == 'step2' || step == 'step3'"
                                xs12
                                md12
                        >
                          <v-textarea
                              rows="1"
                              auto-grow
                              v-model="language.postData.chatbot_response_genuine"
                              label="ChatBot response Genuine"
                              class="purple-input"/>
                        </v-flex>
                        <v-flex v-if="step == 'step2' || step == 'step3'"
                                xs12
                                md12
                        >
                          <v-textarea
                              v-model="language.postData.chatbot_response_fake"
                              label="ChatBot response Fake"
                              class="purple-input"/>
                        </v-flex>
                        <!--  Step3-->
                        <v-flex
                            xs12
                            md12
                        >
                          <v-btn
                              v-if="step == 'step2'  && step != 'step1' "
                              dark
                              fab
                              bottom
                              right
                              color="grey"
                              style="float: right; left: 0;"
                              @click="step ='step3'"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex v-if="step === 'step3'"
                                xs12
                                md12
                        >
                          <v-text-field
                              v-model="language.postData.top_tips"
                              label="Top Tips"
                              class="purple-input"/>
                        </v-flex>
                        <v-flex v-if="step === 'step3'"
                                xs12
                                md12
                        >
                          <v-text-field
                              v-model="language.postData.bottom_tips"
                              label="Bottom_tips Tips"
                              class="purple-input"/>
                        </v-flex>
                      </v-layout>
                    </v-form>
                    <br>
                  </v-flex>
                </v-list-tile>
              </v-list>
            </v-tab-item>
            <v-flex
                xs12
                text-xs-right>
              <v-btn  v-if="!postEdit" :disabled="isDisabled"
                      @click="postSubmit"
                      class="mx-0 font-weight-light"
                      color="success"
              >
                Save
              </v-btn>
              <v-btn v-if="postEdit" :disabled="isDisabled" @click="postSubmit" class="mx-0 font-weight-light" color="success">
                Update
              </v-btn>
            </v-flex>
          </v-tabs-items>
        </material-card>
      </v-flex>
      <v-flex xs12 md4>
        
        <material-card class="v-card-profile" style="    margin-top: 15%;">
          <v-card-text class="text-xs-center" style="    width: 300px;" >
            <v-form class="add-blog-form justify-space-between">
              <dropzone id="myVueDropzone" class="mb-2" ref="myVueDropzone"
                        :options="dropzoneOptions"
                        v-on:vdropzone-error="onVdropzoneError"
                        v-on:vdropzone-file-added="newFileAdded = true"
                        v-on:vdropzone-success="onVdropzoneSuccess"
                        v-on:vdropzone-max-files-exceeded="onVdropzoneMaxFilesExceeded"
              >
              </dropzone>
              <img style="box-shadow: none" height="200px" ref="myimg" width="200px" v-if="postEdit == true && newFileAdded == false" :src="src">
            </v-form>
          </v-card-text>
        </material-card>
        <material-card class="v-card-profile" style="margin-top: 15%;" v-if="step == 'step3'">
          <v-card-text class="text-xs-center" style="    width: 300px;" >

            <v-form class="add-blog-form justify-space-between">
              <dropzone id="myVueDropzone" class="mb-2" ref="myVueDropzone"
                        :options="dropzoneOptions1"
                        v-on:vdropzone-file-added="newFileTAdded = true"
                        v-on:vdropzone-error="onVdropzoneError"
                        v-on:vdropzone-success="onVdropzoneSuccess1"
                        v-on:vdropzone-max-files-exceeded="onVdropzoneMaxFilesExceeded1"
              >
              </dropzone>
              <img style="box-shadow: none" height="200px" ref="myimg" width="200px" v-if="postEdit === true && newFileTAdded === false" :src="thumbnailTutorial">
            </v-form>
          </v-card-text>
        </material-card>
        <br>
        <material-card class="v-card-profile mobile-profile">
          <div class="custom-flex-container">
            <div class="custom-row">
              <div class="custom-flex-item">
                <v-btn
                    class="btn-preview"
                    color="primary"
                    dark
                    @click.stop="dialog = true"
                >
                  Preview
                </v-btn>
              </div>
            </div>
          </div>
        </material-card>
        <br/>
        <v-flex class="example-wrap-1" style="">
          <div><v-btn @click="showExample" class="mx-0 font-weight-light example-btn-1" color="success" @click.stop="dialogExample1 = true">
                TUTORIAL
              </v-btn></div>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card class="mobile-container">
            <v-btn dark flat @click="dialog = false" class="mobile-close-btn">
              <v-icon>close</v-icon>
            </v-btn>
            <div id="mobile-view">
              <div class="index page">
                <div class="real-page">
                  <div class="product-img product-real">
                    <div class="micon" style="height: 80px;">
                      <img src="/img/product_real_icon.png" draggable="true">
                    </div>
                    <div class="img main-img-height">
                      <div class="main-img-height" :style="{'background-image': 'url('+previewProductImage+')'}" style="background-size: 100% 100%; background-repeat: no-repeat;"></div>
                      <img :src="previewProductImage" draggable="true">
                    </div>
                  </div>
                  <div class="info-item single" v-if="ifNotEmpty(languages[languageIndex].postData.top_middle_title)">
                    <p class="txt big"><span v-text="languages[languageIndex].postData.top_middle_title"></span></p>
                  </div>
                  <div class="info-item" v-if="ifNotEmpty(languages[languageIndex].postData.info_title_1) || ifNotEmpty(languages[languageIndex].postData.info_small_title_1)">
                    <div class="info-title" v-if="ifNotEmpty(languages[languageIndex].postData.info_title_1)">
                      <p class="txt"><span v-text="languages[languageIndex].postData.info_title_1"></span></p>
                    </div>
                    <div class="info-content" v-if="ifNotEmpty(languages[languageIndex].postData.info_small_title_1)">
                      <p class="txt small"><span v-text="languages[languageIndex].postData.info_small_title_1"></span></p>
                    </div>
                  </div>
                  <div class="info-item" v-if="ifNotEmpty(languages[languageIndex].postData.info_title_2) || ifNotEmpty(languages[languageIndex].postData.info_title_2)">
                    <div class="info-title" v-if="ifNotEmpty(languages[languageIndex].postData.info_title_2)">
                      <p class="txt"><span v-text="languages[languageIndex].postData.info_title_2"></span></p>
                    </div>
                    <div class="info-content" v-if="ifNotEmpty(languages[languageIndex].postData.info_small_title_2)">
                      <p class="txt small"><span v-text="languages[languageIndex].postData.info_small_title_2"></span></p>
                    </div>
                  </div>
                  <div class="info-item" v-if="ifNotEmpty(languages[languageIndex].postData.info_title_3) || ifNotEmpty(languages[languageIndex].postData.info_small_title_3)">
                    <div class="info-title" v-if="ifNotEmpty(languages[languageIndex].postData.info_title_3)">
                      <p class="txt"><span v-text="languages[languageIndex].postData.info_title_3"></span></p>
                    </div>
                    <div class="info-content" v-if="ifNotEmpty(languages[languageIndex].postData.info_small_title_3)">
                      <p class="txt small"><span v-text="languages[languageIndex].postData.info_small_title_3"></span></p>
                    </div>
                  </div>
                  <div class="info-item" v-if="ifNotEmpty(languages[languageIndex].postData.info_title_4) || ifNotEmpty(languages[languageIndex].postData.info_small_title_4)">
                    <div class="info-title" v-if="ifNotEmpty(languages[languageIndex].postData.info_title_4)">
                      <p class="txt"><span v-text="languages[languageIndex].postData.info_title_4"></span></p>
                    </div>
                    <div class="info-content" v-if="ifNotEmpty(languages[languageIndex].postData.info_small_title_4)">
                      <p class="txt small"><span v-text="languages[languageIndex].postData.info_small_title_4"></span></p>
                    </div>
                  </div>
                  <div class="info-item" v-if="ifNotEmpty(languages[languageIndex].postData.info_title_5) || ifNotEmpty(languages[languageIndex].postData.info_small_title_5)">
                    <div class="info-title" v-if="ifNotEmpty(languages[languageIndex].postData.info_title_5)">
                      <p class="txt"><span v-text="languages[languageIndex].postData.info_title_5"></span></p>
                    </div>
                    <div class="info-content" v-if="ifNotEmpty(languages[languageIndex].postData.info_small_title_5)">
                      <p class="txt small"><span v-text="languages[languageIndex].postData.info_small_title_5"></span></p>
                    </div>
                  </div>
                </div>
                <div class="info-item single  btn-wrap">
                  <div class="part-btn ">
                    <button class="white-btn">New scan</button>
                  </div>
                  <div class="part-btn ">
                    <button class="white-btn">Home</button>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-dialog>
      </v-layout>
    <v-layout row justify-center>
        <v-dialog v-model="dialogExample1" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card class="mobile-container">
            <v-btn dark flat @click="dialogExample1 = false" class="mobile-close-btn">
              <v-icon>close</v-icon>
            </v-btn>
            <div id="mobile-view" class="demo-show">
              <!-- <v-btn @click="showExample" class="mx-0 font-weight-light next-btn-1" color="success" @click.stop="showScreenshot1 = !showScreenshot1">
                    TUTORIAL
                  </v-btn> -->
              <div class="index page">
                <div class="real-page">
                  
                  <div class="product-img2 product-real" v-show="showScreenshot1">
                      <img :src="exampleScreenShot"  class="example-screenshot" >
                  </div>
                  <div class="product-img2 product-real">
                      <img :src="exampleScreenShot2"  class="example-screenshot" >
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-dialog>
      </v-layout>
  </v-container>
</template>
<script>
  import {
    postDataAdd,
    getpost,
    getLanguagesApi,
    checkUniqueSku,
    checkUniqueBatchNumber,
    checkTagUniqueness
  } from "../api/routes";
  import Dropzone from "vue2-dropzone";
  import AppConfig from "../constants/AppConfig";
  import * as $ from 'jquery';
  import {getDiff, validator} from '../plugins/validator';
export default {
  name: "AddEdit",
  components: {
    Dropzone
  },
  data () {
    return {
      previewProductImage: '/img/no-image.png',
      languageIndex: 0,
      dialog: false,
      dialogExample1: false,
      exampleScreenShot: 'https://cdn-zh.cypheme-cn.com/2022/static/img/screenshot1.jpeg',
      exampleScreenShot2: 'https://cdn-zh.cypheme-cn.com/2022/static/img/screenshot3.png?v=1',
      showScreenshot1: true,
      step:false,
      select: [],
      items: [],
      search: "",
      renderComponent:false,
      batchNumber: '',
      allTags: [],
      options: [],
      selected: [],
      thumbnail: '',
      src: '',
      errorMsg: [],
      thumbnailTutorial: '',
      newFileAdded: false,
      newFileTAdded: false,
      postTags: null,
      validpostForm:true,
      dropzoneOptions: {
        url: AppConfig.janeAPI+'post/uploadImages',
        maxFilesize: 1,
        maxFiles: 1,
        paramName:'capture_image',
        capture: 'image/',
        acceptedFiles: ".png,.jpg,.jpeg,.gif",
        dictDefaultMessage: " <img style='width: 100px; cursor:pointer; box-shadow:none' for='myVueDropzone' src='https://cdn.pixabay.com/photo/2016/01/03/00/43/upload-1118929_960_720.png'> <br>PRODUCT IMAGE UPLOAD",
        headers: { Authorization: `Bearer ${ sessionStorage.getItem('AUTH_TOKEN')}` }
      },
      dropzoneOptions1: {
        url: AppConfig.janeAPI+'post/uploadImages',
        maxFilesize: 1,
        maxFiles: 1,
        paramName:'capture_image',
        acceptedFiles: ".png,.jpg,.jpeg,.gif",
        capture: 'image/',
        dictDefaultMessage: " <img style='width: 100px; cursor:pointer; box-shadow:none' for='myVueDropzone' src='https://cdn.pixabay.com/photo/2016/01/03/00/43/upload-1118929_960_720.png'> <br>TUTORIAL IMAGE UPLOAD",
        headers: { Authorization: `Bearer ${ sessionStorage.getItem('AUTH_TOKEN')}` }
      },
      uploadedImages:'noimage.png',
      postData:{
        title:'',
        small_title_1:'',
        small_tip_1:'',
        small_title_2:'',
        small_tip_2:'',
        middle_title:'',
        tags:{},
        original_batch_value: '',
        searchTags:"",
        types:[]
      },
      messages:{
        title:[],
        small_title_1:[],
        small_tip_1:[],
        small_title_2:[],
        small_tip_2:[],
        middle_title:[],
        tags:[],
        types:[],
      },
      languages:[],
      valid: true,
      tabs: 0,
      active_tab: 'tab-1',
      postid: null,
      postEdit: false,
      types: [],
      statusSwitch:true,
      titleRules: [
        v => !!v || "Title is required",
        v => v.length <= 100 || "Name must be less than 100 characters",
      ],
      middleTitleRules: [
        v => !!v || "Middle title is required",
        v => v.length <= 100 || "Name must be less than 100 characters",
      ],
      batchNumberRules: [
        v => !!v || "Batch Number is required",
        v => v.length <= 100 || "Name must be less than 100 characters",
      ],
      imageName: '',
      skuError: '',
      imageUrl: '',
      imageFile: '',
      uploadedTutorialImages:'noimage.png',
      sku: '',
      isBatchNumberUnique: false,
    }
  },
  beforeMount() {
    this.getLanguages();
  },
  mounted() {
    if(typeof this.$route.params.id != 'undefined'){
      this.postid = this.$route.params.id;
      this.postEdit=true;
      this.getPostData();
    }else{
      this.postEdit=false
    }
    var item = localStorage.getItem('CURRENT_LANGUAGE');
    if( localStorage.getItem('CURRENT_LANGUAGE') === '') {
      if(this.tabs === 0){
        this.tabs = 1;
      }
    }
  },
  watch: {
    errorMsg: function(val){
      this.valid = this.errorMsg.length <= 0;
    },
    batchNumber: function(){
      return this.checkUniqueBatch();
    },
    $route(to, from){
      this.$refs.myimg.src = "";

      //this.$refs.postForm.reset();
      //this.postData.types =[];
    }
  },
  computed: {
    isDisabled: function(){
      if(!this.sku || !this.languages[0].postData.top_middle_title || this.select.length <= 0 || this.skuError)
        return true;
      return false;
    },
    likesAllTags () {
      var current_language = this.tabs;
      return this.languages[current_language].postData.tags.length === this.allTags.length
    },
    likesSomeTag () {
      var current_language = this.tabs;
      return this.languages[current_language].postData.tags.length > 0 && !this.likesAllTags
    },
    icon () {
      if (this.likesAllTags) return 'mdi-close-box'
      if (this.likesSomeTag) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    validateAllforms(){
      if (!this.isBatchNumberUnique){
        return false;
      }
      var valid = true;
      for(var i = 0; i< this.languages.length;i++){
        var formName = 'form'+this.languages[i].name
        valid = valid && this.$refs[formName][0].validate()
      }
      return valid;
    }
  },
  methods: {
    ifNotEmpty: function(value){
      return value !== undefined && value !== '';
    },
    previewClicked: function(){
      this.previewEnabled = true
    },
    checkUniqueSku: _.debounce(function (e) {
      this.valid = false;
      if (!this.sku){
        this.skuError = '';
        return;
      }
      let postData = {
        sku: this.sku,
        postId: this.postid
      }
      checkUniqueSku(postData)
          .then(resp => resp.data)
          .then(resp => {
            if (resp.status === 'error'){
              this.skuError = resp.msg;
              this.valid = false;
            } else {
              this.skuError = '';
              this.valid = true;
            }
          }).catch(this.errorCb)
    }, 1000),
    errorCb: function (error){
      console.log(error)
    },
    verifyTags: function(){
      let values = this.select;
      if (values.length === 0){
        this.errorMsg = '';
        return;
      }
      this.errorMsg = [];
      this.select = [];
      let data =  validator(values)
      this.$nextTick(() => {
        this.select.push(...data[0]);
        this.errorMsg.push(...data[1]);
        let diff = '';
        if (this.postTags)
          diff = getDiff(this.select, this.postTags)
        else
          diff = this.select;
        let postData = {
          tags : diff,
          postId : this.postid
        };
        checkTagUniqueness(postData)
            .then(resp => resp.data)
            .then(resp => {
              if (resp.status === 'success'){
                this.$toasted.error(resp.msg).goAway(3000);
                this.errorMsg.push(resp.msg);
              }
            })
            .catch(error => {
              console.log(error);
            });
      });
      // verifyIntersection(values);
      // return;
    },
    updateTags() {
      this.$nextTick(() => {
        if (!this.search)
          return;
        this.select.push(...this.search.split(","));
        this.$nextTick(() => {
          this.search = "";
        });
      });
    },
    addPendingTags(){},
    checkUniqueBatch: function(){
      if (this.batchNumber === this.original_batch_value || !this.batchNumber){
        return
      }
      checkUniqueBatchNumber({ batchNumber : this.batchNumber}).then(resp => {
        if (resp.data.message === 0){
          this.$toasted.show('Batch number should be unique');
          this.isBatchNumberUnique = false;
          this.valid = false;
        }
        else {
          this.isBatchNumberUnique = true;
        }
      }).catch(error =>{
        console.log('Error in verifying batch number');
      })
    },
    toggle () {
      this.$nextTick(() => {
        var current_language = this.tabs;
        if (this.likesAllTags) {
          this.languages[current_language].postData.tags = []
        } else {
          this.languages[current_language].postData.tags = this.allTags.slice()
        }
      })
    },
    convertToArray(obj){
      var result = Object.keys(obj).map(function(key) {
        return [obj[key]];
      });
      return result;
    },
    changeLanguage (tab, index) {
      this.tabs = tab;
      this.active_tab=this.tabs;
      this.languageIndex = index;
    },
    ifNotEmptyFields() {
      return false;
    },
    showExample() {
      console.log("kkk")
    },
    nextExample() {
      console.log("kkk")
    },
    postSubmit() {
      if (this.validateAllforms || this.checkUniqueSku || this.checkUniqueBatch) {
        var postData = {
          post:this.languages,
          image: this.uploadedImages,
          tutorial_image: this.uploadedTutorialImages,
          status: this.statusSwitch,
          batchNumber: this.select,
          sku: this.sku,
        }
        if(this.postEdit){
          postData.id = this.postid
        }
        postDataAdd(postData)
            .then(response => {
              if(this.postEdit){
                this.$toasted.show('Post has been updated successfully!')
                this.$router.push('/list');
              }else{
                this.$refs.myVueDropzone.removeAllFiles();
                this.$toasted.show('Post has been added successfully!');
                this.$router.push({
                  name: 'Posts'
                });
                //this.clearForms()
              }
            })
            .catch(error => {
              console.log(error);
              let errors = error.response.data.errors;
              if (errors) {
                for (let field in errors) {
                  // this.messages[field] = errors[field]
                }
              }
              this.$toasted.show('Please validate form!')
            })
            .finally(() => {
            })
      }else{
        this.$toasted.show('Please validate form!')
      }
    },
    onVdropzoneMaxFilesExceeded(file){
      this.$refs.myVueDropzone.removeAllFiles();
      this.$refs.myVueDropzone.addFile(file);
    },
    onVdropzoneSuccess(file, response){
      this.hasError=false
      this.uploadedImages = response.images;
      file.previewElement.childNodes[1].children[0].setAttribute('src', AppConfig.jane+'storage/post_images/'+response.images);
      file.previewElement.childNodes[1].children[0].setAttribute('height', '240px');
      file.previewElement.childNodes[1].children[0].setAttribute('width', '240px');
      this.previewProductImage = AppConfig.jane+'storage/post_images/'+response.images;
    },
    onVdropzoneError(file, x){
      $('.dz-error-message span').text(x.msg);
    },
    onVdropzoneMaxFilesExceeded1(file){
      console.log(file);
    },
    onVdropzoneSuccess1(file, response){
      this.hasError=false
      this.uploadedTutorialImages = response.images
    },
    clearForms(){
      for(var i = 0; i< this.languages.length;i++){
        var formName = 'form'+this.languages[i].name
        this.$refs[formName][0].reset()
      }
    },
    getPostData(){
      getpost({id:this.postid})
          .then(response => {
            response = response.data
            let tags = response.tags;
            this.postTags = [];
            for (let i = 0; i < tags.length; i++) {
              let currentTag =tags[i];
              if (currentTag.batch_number)
                this.select.push(currentTag.batch_number);
              let start = currentTag.start;
              let end = currentTag.end;
              if (!start)
                continue;
              if (start === end && currentTag.original_start){
                this.select.push(currentTag.original_start);
                this.postTags.push(currentTag.original_start);
              }
              else if(currentTag.original_start){
                this.select.push(currentTag.original_start + '-' + currentTag.original_end);
                this.postTags.push(currentTag.original_start + '-' + currentTag.original_end);
              }
            }
            this.sku = response.sku;
            this.original_batch_value = response.batch_number;
            for(var i = 0; i< response.post_transalation.length;i++){
              var postData =response.post_transalation[i];
              this.languages[i].postData.top_middle_title = postData.top_middle_title || ''
              this.languages[i].postData.info_title_1 = postData.info_title_1 ||''
              this.languages[i].postData.info_small_title_1 = postData.info_small_title_1 ||''
              this.languages[i].postData.info_title_2 = postData.info_title_2 ||''
              this.languages[i].postData.info_small_title_2 = postData.info_small_title_2 ||''
              this.languages[i].postData.info_title_3 = postData.info_title_3 ||''
              this.languages[i].postData.info_small_title_3 = postData.info_small_title_3 ||''
              this.languages[i].postData.info_title_4 = postData.info_title_4 ||''
              this.languages[i].postData.info_small_title_4 = postData.info_small_title_4 ||''
              this.languages[i].postData.info_title_5 = postData.info_title_5 ||''
              this.languages[i].postData.info_small_title_5 = postData.info_small_title_5 ||''
              this.languages[i].postData.fake_product_text = postData.fake_product_text ||''
              this.languages[i].postData.bottom_tips = postData.bottom_tips ||''
              this.languages[i].postData.top_tips = postData.top_tips ||''
              this.languages[i].postData.image = postData.image ||''
              this.languages[i].postData.tags = postData.tags_data ||[]
              this.languages[i].postData.types = postData.types_data ||[]
              this.languages[i].postData.chatbot_response_fake = postData.chatbot_response_fake || ""
              this.languages[i].postData.chatbot_response_genuine = postData.chatbot_response_genuine || ""
              this.languages[i].postData.serial_number_title = postData.serial_number_title || ""
            }
            this.uploadedImages =response.image || this.uploadedImages
            this.statusSwitch =response.status
            this.statusSwitch = this.statusSwitch === 1;
            this.thumbnail =response.thumbnail || ''
            this.src =response.src || ''
            this.thumbnailTutorial =response.tutorial || ''
            if(this.uploadedImages)
              this.previewProductImage = AppConfig.jane+'storage/post_images/'+this.uploadedImages;
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
          })
    },
    getLanguages(){
      getLanguagesApi().then(resp => {
        var languages =[];
        languages = resp.data.data;
        this.languages = languages;
        this.renderComponent = true;
      }).catch(error => {
        console.log(error)
      });
    },
  }
}
</script>
<style>
  .dz-success-mark {
    display: none !important;
  }
 .dz-error-mark{
   display: none !important;
  }
</style>
<style scoped>
::-webkit-scrollbar {
  display: none;
}
#mobile-view{
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
#mobile-view .index .micon img {
  width: 100%;
}
#mobile-view .index .main-img-height {
  height: 292px;
}
#mobile-view .index .img img {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100%;
  right: 0;
  left: 0;
  display: none;
}
#mobile-view .index .info-item.single {
  height: auto;
  min-height: 30px;
  padding: 0 10px;
  text-align: center;
}
#mobile-view .index .info-item {
  height: auto;
  min-height: 46px;
  margin: 5px 0 0;
  background-color: #fff;
  padding: 5px 10px;
}
#mobile-view .index .real-page .product-img {
  position: relative;
}
#mobile-view .index .real-page .product-img .micon {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 90px;
  z-index: 10;
  display: block;
}
#mobile-view .index .real-page .product-img .img {
  width: 100%;
  display: block;
}
#mobile-view .index .info-item.single .big {
  line-height: 30px;
  text-align: center;
  font-size: 18px !important;
  margin: 0 0 10px;
  font-weight: lighter;
  font-family: sans-serif;
}
#mobile-view .index .info-item .info-title {
  margin-bottom: 5px;
  line-height: 1.2;
}
#mobile-view .index .info-item .info-title p.txt{
  font-size: 16px !important;
  font-family: sans-serif;
  margin-bottom: 5px;
}
.info-item.single.btn-wrap {
  padding-bottom: 5px !important;
}
#mobile-view .index .info-item .info-content {
  line-height: 1;
}
#mobile-view .index .info-item .txt.small {
  font-size: 12px !important;
  line-height: 16px;
  margin-bottom: 0px;
}
.part-btn {
  display: inline-block;
  width: 49%;
}
.part-btn .white-btn::after {
  content: " ";
  width: 200%;
  height: 200%;
  position: absolute;
  top: 0;
  left: 0;
  border: 1px solid rgba(0,0,0,.2);
  -webkit-transform: scale(.5);
  transform: scale(.5);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  box-sizing: border-box;
  border-radius: 10px;
}
.info-item.hidden {
  display: none;
}
.part-btn .white-btn {
  background-color: #ffffff;
  margin: 5px 10px;
  -moz-box-shadow: 1px 4px 2px #bbb;
  -webkit-box-shadow: 1px 4px 2px #bbb;
  box-shadow: 1px 4px 2px #bbb;
  font-size: 18px;
  text-align: center;
  line-height: 2.55555556;
  color: #000;
  cursor: pointer;
  position: relative;
  display: block;
  padding-left: 14px;
  padding-right: 14px;
  box-sizing: border-box;
  text-decoration: none;
  border-radius: 5px;
  -webkit-tap-highlight-color: transparent;
  overflow: hidden;
  font-family: sans-serif;
  font-weight: lighter;
  width: 135px;
}
.btn-preview:hover,
.btn-preview{
  background: #4caf50 !important;
  box-shadow: none !important;
}
.mobile-close-btn{
  position: absolute;
  right: 15px;
  top: 15px;
  border: 1px solid #fff;
}
.mobile-container{
  display: flex;
  justify-content: center;
  align-items: center;
  /*background: #000000f2;*/
  background: #c8c8c8;
}
#mobile-view {
  min-width: 360px;
  min-height: 640px;
  overflow-y: scroll;
  width: 360px;
  height: 640px;
  max-width: 360px;
  max-height: 640px;
  border-radius: 4px;
  background: #e6e6e6;
  overflow-x: hidden;
}
/*.custom-modal{
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
}
.custom-modal-backdrop{
  width: 100%;
}
.custom-modal-body{
  display: flex;
  justify-content: center;
  align-items: center;
}*/
.v-card-profile.mobile-profile{
  width: 330px !important;
}
.custom-flex-container {
  height: 100%;
  padding: 0;
  margin: 0;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
}
/*
.custom-row {
}
.custom-flex-item {
}*/
.lable-tip1 {
  font-size: 0.8em;
}
.example-screenshot {
  width: 100%;
}
.next-btn-1 {
  position: absolute;
  right: 30px;
  top: 200px;
}
.example-wrap-1 {
  width:330px;
  text-align: center;
}
.example-btn-1 {
  background-color: #0080ab !important;
}
#mobile-view .index .real-page .product-img2 {
  position: relative;
}
#mobile-view.demo-show {
  width: 650px;
  max-width: inherit;
}
#mobile-view.demo-show .real-page {
  display: flex;
  flex-direction: row;
}
#mobile-view.demo-show .example-screenshot {
  width: 300px;
  margin-right: 10px;
  margin-left: 10px;
}
.v-btn.success:focus, .v-btn.success:active, .v-btn.success:hover {
    background-color: #0080ab !important;
}

</style>